import { render } from "./CaricamentiMultisito.vue?vue&type=template&id=0999ea75&scoped=true"
import script from "./CaricamentiMultisito.vue?vue&type=script&lang=js"
export * from "./CaricamentiMultisito.vue?vue&type=script&lang=js"

import "./CaricamentiMultisito.vue?vue&type=style&index=0&id=0999ea75&lang=css"
import "./CaricamentiMultisito.vue?vue&type=style&index=1&id=0999ea75&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0999ea75"]])

export default __exports__